import { useNumericParams } from '@domain-group/react-hooks'

import CampaignRoutes from './routes'

const Campaign = () => {
  const { campaignId } = useNumericParams()

  return (
    <CampaignRoutes />
  )
}

export default Campaign
